<template>
<div>
    <select v-model="$parent.selectedStatus">
  <option>All</option>
<option v-for="item in list">{{item}}</option>
</select>
	</div>
</template>

<script>
export default {
  name: 'StatusSelect',
 	props: ['list'],
	data() {
		return {
			loading: false,
		}
	},
	methods: {
       selectItem(){      
                 }
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


